import { formatISO, parseISO } from 'date-fns';

export const mergeDateTime = (date: Date, time: Date): Date => {
  const newDate = formatISO(date, { representation: 'date' });
  const newTime = formatISO(time, { representation: 'time' });
  return parseISO(`${newDate}T${newTime}`);
};
